<form #form="ngForm" novalidate class="cliente-analise-mercado-form">
    <sgt-cliente-analise-mercado-header
        [idCliente]="entity?.idCliente"
        [tipoPessoa]="entity?.tipoPessoa"
        [codigoIntegracaoErpCliente]="entity?.codigoIntegracaoErpCliente"
        [cnpjCpfCliente]="entity?.cnpjCpfCliente"
        [nomeCliente]="entity?.nomeCliente"
        [nomeFantasiaCliente]="entity?.nomeFantasiaCliente"
        [nomeCidadeCliente]="entity?.nomeCidadeCliente"
        [ufCliente]="entity?.ufCliente"
        [codigoIntegracaoErpRepresentante]="entity?.codigoIntegracaoErpRepresentante"
        [nomeRepresentante]="entity?.nomeRepresentante"
        [nomeFantasiaRepresentante]="entity?.nomeFantasiaRepresentante"
        [ano]="entity?.ano">                
    </sgt-cliente-analise-mercado-header>

    <!-- Classificações -->
    <sgt-cliente-analise-mercado-classificacao-lancamento
        #clienteAnaliseMercadoClassificacaoLancamento
        [idCliente]="entity?.idCliente"
        [ano]="entity?.ano"
        [idClienteAnaliseMercado]="entity?.id"
        [perspectiva]="perspectiva"
        (afterCreateLancamento)="afterCreateLancamentoClassificacao($event)"
        (afterDeleteLancamento)="afterDeleteLancamentoClassificacao()"
        (openLancamento)="openLancamentoClassificacao($event)">
    </sgt-cliente-analise-mercado-classificacao-lancamento>
</form>

<sgt-cliente-analise-mercado-lancamento-form-modal
    #lancamentoFormModal
    (afterSave)="afterSaveLancamentoClassificacao()">
</sgt-cliente-analise-mercado-lancamento-form-modal>